(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart--flyout"]) return;
  try {
    

    const overlay = document.querySelector(".overlay");
    const cartCloseButton = document.querySelector("#cart-flyout__close-button");
    const cartOpenButton = document.querySelector("#nav__cart-button");
    const addToCartForm = document.querySelector('form[action="/cart/add"]');

    function openCart() {
        overlay.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }

    function closeCart() {
        overlay.classList.remove("is-open");
        document.body.style.overflow = "";
    }

    cartOpenButton.addEventListener("click", (e) => {
        e.preventDefault();
        openCart();
    })

    cartCloseButton.addEventListener("click", (e) => {
        e.preventDefault();
        closeCart();
    })

    overlay.addEventListener('click', async (e) => {
        if (e.target === overlay) {
            closeCart();
            return;
        }

        if (e.target.closest('a[href*="/cart/change"]')) {
            e.preventDefault();
            const url = e.target.closest('a').href;
            await fetch(url);
            await fetchAndRenderCart();
            return;
        }

        if (e.target.closest('[data-action="add"]')) {
            const btn = e.target.closest('[data-action="add"]');
            const key = btn.dataset.key;
            const newQty = parseInt(btn.dataset.qty) + 1;

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: newQty })
            })

            await fetchAndRenderCart();
        }
    })

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeCart();
    })

    async function fetchAndRenderCart() {
        const [sectionsResponse, cartResponse] = await Promise.all([
            fetch('/?sections=cart--flyout'),
            fetch('/cart.js')
        ])

        const data = await sectionsResponse.json();
        const cart = await cartResponse.json();

        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart--flyout'], 'text/html');
        const newCart = doc.querySelector('.overlay');

        overlay.innerHTML = newCart.innerHTML;

        document.querySelector('#nav__cart-button').textContent = `Cart\u00a0\u00a0${cart.item_count}`;

        document.querySelector('#cart-flyout__close-button').addEventListener('click', (e) => {
            e.preventDefault();
            closeCart();
        })
    }

    if (addToCartForm) {
        addToCartForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const formData = new FormData(addToCartForm);

            await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })

            await fetchAndRenderCart();
            openCart();
        })
    }

    function formatMoney(cents) {
        const amount = cents / 100;
        return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
    const formatMoney = (cents) => {
        const amount = cents / 100;
        return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
    }

    document.querySelectorAll("[data-action='add']").forEach(btn => {
        btn.addEventListener("click", async () => {
            btn.disabled = true;

            const key = btn.dataset.key;
            const newQty = parseInt(btn.dataset.qty) + 1;

            try {
                const res = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: key, quantity: newQty })
                })

                const cart = await res.json();
                const updatedItem = cart.items.find(i => i.key === key);

                if (updatedItem) {
                    document.getElementById(`qty-${key}`).textContent = updatedItem.quantity;
                    btn.dataset.qty = updatedItem.quantity;

                    const lineTotal = document.getElementById(`line-total-${key}`);
                    if (lineTotal) lineTotal.textContent = formatMoney(updatedItem.line_price);

                    const cartTotal = document.getElementById("cart-total");
                    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
                }

            } finally {
                btn.disabled = false;
            }
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header-filters"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
    const main = document.querySelector("main");
    let isOpen = false;

    async function applyFilters(href, keepOpen = false) {
        const filterUrl = new URL(href);
        
        if (keepOpen) {
            filterUrl.searchParams.set("filters_open", "true");
        }
        
        filterUrl.searchParams.set("sections", "collection-header-filters,collection-editorial");

        const grid = document.querySelector("[id*='collection-editorial']");
        grid.style.opacity = "0";

        const response = await fetch(filterUrl.toString());
        const data = await response.json();
        const parser = new DOMParser();

        const newHeaderDoc = parser.parseFromString(data["collection-header-filters"], "text/html");
        document.querySelector("[id*='collection-header-filters']").innerHTML = 
            newHeaderDoc.querySelector("[id*='collection-header-filters']").innerHTML;

        const newGridDoc = parser.parseFromString(data["collection-editorial"], "text/html");
        document.querySelector("[id*='collection-editorial']").innerHTML = 
            newGridDoc.querySelector("[id*='collection-editorial']").innerHTML;

        filterUrl.searchParams.delete("sections");
        window.history.pushState({}, "", filterUrl.toString());

        window.destroySwipers?.();
        window.initSwipers?.();
        
        const newGrid = document.querySelector("[id*='collection-editorial']");
        const thumbs = document.querySelectorAll(".collection__product-thumb--4-up");
        newGrid.style.opacity = "1";

        thumbs.forEach((thumb, i) => {
            thumb.style.opacity = "0";

            setTimeout(() => {
                thumb.style.opacity = "1";
            }, i * 100);
        });

        initFilters(keepOpen);
        lastScrollY = window.scrollY;
    }

    main.addEventListener("click", (e) => {
        const link = e.target.closest(".collection__filter-value, .collection__filter-tag, .collection__filter-clear");

        if (link) {
            e.preventDefault();

            if (link.classList.contains("collection__filter-clear")) {
                window.location.href = link.href;
                return;
            }

            const targetUrl = new URL(link.href);
            const hasFilters = targetUrl.search.includes("filter.");
            const hasSort = targetUrl.searchParams.get("sort_by");
            
            if (!hasFilters && !hasSort) {
                const navUrl = new URL(link.href);

                if (isOpen && !link.classList.contains("collection__filter-clear")) {
                    navUrl.searchParams.set("filters_open", "true");
                }

                window.location.href = navUrl.toString();
                return;
            }

            applyFilters(link.href, isOpen);
        }
    });

    function initFilters(startOpen = false) {
        const lensFilters = document.querySelectorAll(".collection__filter-group--lens .collection__filter-value");
        const frameFilters = document.querySelectorAll(".collection__filter-group--frame .collection__filter-value");
        const filterToggle = document.querySelector(".collection__filter-toggle");
        const filters = document.querySelector(".collection__filters");
        const collectionHeader = document.querySelector(".collection-header--filters");
        const filterOverview = document.querySelector(".collection__filter-overview");
        const filterBar = document.querySelector(".collection__filter-bar");
        const toggleIcon = filterToggle.querySelector(".collection-filter-toggle__toggle-icon");
        const filterApplyButton = document.querySelector(".collection__apply-button");
        const isFiltered = parseInt(filters.dataset.filtered) > 0;

        function setFiltersOpen(open) {
            isOpen = open;
            if (open) {
                setHeaderVisible(true);
                lastScrollY = window.scrollY;
            }

            filters.classList.toggle("is-open", open);
            collectionHeader.classList.toggle("is-open", open);
            filterOverview.classList.toggle("is-collapsed", open);
            filterBar.classList.toggle("is-hidden", open);
            toggleIcon.textContent = open ? "−" : "+";
            filterToggle.setAttribute("data-open", open);
            filterApplyButton.classList.toggle("is-open", open);

            const url = new URL(window.location.href);
            if (open) {
                url.searchParams.set("filters_open", "true");

            } else {
                url.searchParams.delete("filters_open");
            }

            window.history.replaceState({}, "", url);
        }

        const url = new URL(window.location.href);

        if (url.searchParams.get("filters_open") === "true") {
            setFiltersOpen(true);
        }

        filterToggle.addEventListener("click", () => setFiltersOpen(!isOpen));
        filterApplyButton.addEventListener("click", () => setFiltersOpen(false));

        function dimUnrelated(associated, targets) {
            targets.forEach(target => {
                const label = target.childNodes[0].textContent.trim();

                if (!associated.includes(label)) {
                    target.classList.add("is-dimmed");
                }
            });
        }

        function clearDimmed() {
            [...lensFilters, ...frameFilters].forEach(f => f.classList.remove("is-dimmed"));
        }

        lensFilters.forEach(lens => {
            lens.addEventListener("mouseenter", () => {
                const lensLabel = lens.childNodes[0].textContent.trim();
                dimUnrelated([lensLabel], lensFilters);
                
                if (isFiltered) return;
                
                const associatedFrames = lens.dataset.frames.split(",").filter(Boolean);
                dimUnrelated(associatedFrames, frameFilters);
            });
            
            lens.addEventListener("mouseleave", clearDimmed);
        });

        frameFilters.forEach(frame => {
            frame.addEventListener("mouseenter", () => {
                const frameLabel = frame.childNodes[0].textContent.trim();
                dimUnrelated([frameLabel], frameFilters);
                
                if (isFiltered) return;
                
                const associatedLenses = frame.dataset.lenses.split(",").filter(Boolean);
                dimUnrelated(associatedLenses, lensFilters);
            });
        
            frame.addEventListener("mouseleave", clearDimmed);
        });
    }

    /* VISIBILITY TOGGLES */

    const desktopQuery = window.matchMedia("(min-width: 1153px)");
    const siteHeader = document.querySelector(".header--shop-all");
    const stickyHeader = document.querySelector(".shopify-section:has(.collection-header--filters)");
    let lastScrollY = window.scrollY;
    let headerVisible = true;
    let scrollTimeout;

    window.addEventListener("scroll", () => {
        if (!desktopQuery.matches) return;
        
        const currentScrollY = window.scrollY;

        if (currentScrollY <= 0) {
            setHeaderVisible(true);
            return;
        }

        if (currentScrollY > lastScrollY) {
            setHeaderVisible(false);
        } else {
            setHeaderVisible(true);
        }

        lastScrollY = currentScrollY;
    });

    stickyHeader.addEventListener("mouseenter", () => {
        if (!desktopQuery.matches) return;
        setHeaderVisible(true);
    });

    siteHeader.addEventListener("mouseenter", () => {
        if (!desktopQuery.matches) return;
        setHeaderVisible(true);
    });

    function setHeaderVisible(visible) {
        if (visible === headerVisible) return;
        if (!visible && isOpen) return;
        headerVisible = visible;
        stickyHeader.style.opacity = visible ? "1" : "0";
    }

    initFilters();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-style-list"]) return;
  try {
    
    const backgrounds = document.querySelectorAll(".index-style-list__background");
    const links = document.querySelectorAll(".index-style-list__link");

    links.forEach(link => {
        const img = new Image()
        img.src = link.dataset.hoverImage
    })

    links.forEach(link => {
        link.addEventListener("mouseenter", () => {
            backgrounds.forEach(bg => bg.classList.remove("active"));
            backgrounds[link.dataset.index].classList.add("active");
        })
    })

  } catch(e) { console.error(e); }
})();
})();
